import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";

import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

import RemoveRedEyeOutlined from "@mui/icons-material/RemoveRedEyeOutlined";
import DeleteOutlineOutlined from "@mui/icons-material/DeleteOutlineOutlined";
import EditOutlined from "@mui/icons-material/EditOutlined";

import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";

import { useDispatch, useSelector } from "react-redux";
import {
  getProductDetails,
  viewProduct,
} from "../../../feature/products/productDetailSlice";
import { openDeleteModal } from "../../../feature/products/deleteProductSlice";
import ProductModals from "./ProductModals";
import { useNavigate } from "react-router-dom";

const selectOption = [
  { value: true, label: "Active" },
  { value: false, label: "Inactive" },
];

export default function ProductTableRow(props) {
  const { mode } = useSelector((state) => state.mode);
  const { imageUrl } = useSelector((state) => state.products);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return (
    <>
      {props?.row?.map((row) => (
        <TableRow key={row.id}>
          <TableCell component='th' scope='row'>
            {row.id}
          </TableCell>
          <TableCell component='th' scope='row'>
            {row.product_name}
          </TableCell>
          <TableCell component='th' scope='row'>
            {row.product_amount}
          </TableCell>
          <TableCell component='th' scope='row'>
            {row.product_discount_price}
          </TableCell>
          <TableCell component='th' scope='row'>
            <img src={imageUrl + row.product_image} alt='' height={80} />
          </TableCell>

          <TableCell>
            <Grid item md={4} xs={8}>
              <TextField
                sx={{
                  width: "100px",
                }}
                fullWidth
                // label='Select State'
                name='state'
                // onChange={handleChange}
                required
                select
                SelectProps={{ native: true }}
                // value={select}
                variant='outlined'
              >
                {selectOption.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </TextField>
            </Grid>
          </TableCell>

          <TableCell component='th' scope='row'>
            <Tooltip title='Edit'>
              <IconButton
                aria-label='edit'
                sx={{
                  "&:hover": {
                    color: "#5fd45f",
                  },
                  color: mode === "light" ? "#222b45" : "#ffffff",
                }}
                onClick={() => navigate(`/editproduct/${row.id}`)}
              >
                <EditOutlined />
              </IconButton>
            </Tooltip>
            <Tooltip title='View'>
              <IconButton
                aria-label='view'
                sx={{
                  "&:hover": {
                    color: "#5fd45f",
                  },
                  color: mode === "light" ? "#222b45" : "#ffffff",
                }}
                onClick={() => dispatch(getProductDetails(row.id))}
              >
                <RemoveRedEyeOutlined />
              </IconButton>
            </Tooltip>
            <Tooltip title='Delete'>
              <IconButton
                aria-label='delete'
                sx={{
                  "&:hover": {
                    color: "#F24C4C",
                  },
                  color: mode === "light" ? "#222b45" : "#ffffff",
                }}
                onClick={() => dispatch(openDeleteModal(row))}
              >
                <DeleteOutlineOutlined />
              </IconButton>
            </Tooltip>
          </TableCell>
        </TableRow>
      ))}

      <ProductModals />
    </>
  );
}
